import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import React from 'react';

class FooterEditButton extends React.Component {
  static defaultProps = {
    enabled: true,
    saveEnabled: true,
  };

  static propTypes = {
    editMode: PropTypes.bool.isRequired,
    enabled: PropTypes.bool,
    onCancel: PropTypes.func,
    onEdit: PropTypes.func,
    onSave: PropTypes.func,
    saveEnabled: PropTypes.bool,
  };

  render() {
    if (!this.props.enabled) {
      return (
        <span className='footer-item' style={{opacity: 0.65, cursor: 'not-allowed'}} >
          <i className='footer-item-icon bl bl-edit fa-2x'/>
          <FormattedMessage id="general.edit" />
        </span>
      );
    }

    if (this.props.editMode) {
      return (
        <span className='footer-item footer-edit-options'>
          <i className='footer-item-icon bl bl-edit fa-2x'/>
          <span className='footer-edit-text'><FormattedMessage id="general.edit" /></span>
          &nbsp;
          <button className='btn btn-default' onClick={this.props.onCancel}><FormattedMessage id="general.cancel" /></button>
          <button className='btn btn-primary' disabled={!this.props.saveEnabled} onClick={this.props.onSave}><FormattedMessage id="general.save" /></button>
        </span>
      );
    }

    return (
      <span className='footer-item' onClick={this.props.onEdit}>
        <i className='footer-item-icon bl bl-edit fa-2x'/>
        <FormattedMessage id="general.edit" />
      </span>
    );

  }
}

export default FooterEditButton;
